import { nanoid } from "nanoid";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import MutableIcon from "src/components/mutable-icon";
import {
  Aerobic,
  AerobicExercise,
} from "src/modules/fithub-shared/interfaces/workout";
import AerobicExerciseComponent from "src/modules/protocols/components/aerobic-exercise";
import { ObsWindow } from "../Header/styles";
import MWProps from "../interfaces";
import { CreateButton } from "../weight/styles";
import { Content, ScrollView, Wrapper } from "./styles";

const AerobicComp: React.FC<MWProps<Aerobic>> = (props) => {
  const [workout, setWorkout] = useState<Aerobic>(
    props.content ?? new Aerobic(),
  );

  function CreateNewExercise() {
    const exercises = [...workout.exercises, new AerobicExercise()];

    setWorkout({ ...workout, exercises });
    props.onChange({ ...workout, exercises });
  }

  function DeleteExercise(exc: AerobicExercise) {
    const exercises = workout.exercises.filter((e) => e !== exc);

    setWorkout({ ...workout, exercises });
    props.onChange({ ...workout, exercises });
  }

  function onChangeExercise(index: number, d: AerobicExercise) {
    const exercises = [...workout.exercises];
    exercises[index] = d;

    setWorkout({ ...workout, exercises });
    props.onChange({ ...workout, exercises });
  }

  return (
    <Wrapper>
      <Content>
        <ScrollView>
          {workout.exercises.map((element, index) => {
            return (
              <AerobicExerciseComponent
                key={"ae" + nanoid()}
                content={element}
                onChange={(d) => onChangeExercise(index, d)}
                onDelete={DeleteExercise}
              />
            );
          })}

          <div className="mx-auto flex">
            <CreateButton onClick={CreateNewExercise}>
              <MutableIcon size={30} icon={MdAdd} />
            </CreateButton>
          </div>
          <ObsWindow>
            <p>Observações do Treino:</p>
            <textarea
              defaultValue={props.obs}
              onBlur={(e) => props.onChangeObs(e.target.value)}
              placeholder="Digite aqui as observações gerais do treino..."
            />
          </ObsWindow>
        </ScrollView>
      </Content>
    </Wrapper>
  );
};

export default AerobicComp;
